<script>
import CommonConstants from '@/common/Constants';
import config from '@/common/genericPanelConf';
import Utils from '@/common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Service from '@/services/material-balance';

import ResponsiveButton from '@/components/generic/ResponsiveButton.vue'
import GenericDataTable from '@/components/generic/GenericDataTable.vue';

export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
        ResponsiveButton,
        GenericDataTable
  },
  data(){
    return {
        filters: {
          referenceMonthDate: Utils.formatDatePlusMonths(Utils.setFirstDayOfMonth(new Date()), -1)
        },
      configuration: {},
      submitted: false,
    }
  },
  validations(){
    return {
      filters: {
        referenceMonthDate: {required}
      }
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    this.configuration = config.getConfiguration('PeriodicMovementBySeaReport');
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'periodicMovementBySeaReport.page_title');
  },
  methods: {
    load() {
        console.log(this.configuration);
        this.submitted = true;

        let filtersCharge = {
          referenceMonthDate: Utils.formatDateForAPI(this.filters.referenceMonthDate),
          chargeDischargeFlag: 'C'
        };

        let filtersDischarge = {
          referenceMonthDate: Utils.formatDateForAPI(this.filters.referenceMonthDate),
          chargeDischargeFlag: 'D'
        };
        
        this.$refs.periodicMovementBySeaReportCharge.filterFromView(filtersCharge, true);
        this.$refs.periodicMovementBySeaReportDischarge.filterFromView(filtersDischarge, true);
        this.submitted = false;
    },
    
    exportExcel(){
            let body  = {
              referenceMonthDate: Utils.formatDateForAPI(this.filters.referenceMonthDate)
            }
            this.$store.dispatch("generic/setLoading", true);

            Service.exportPeriodicMovementBySeaExcel(body, ({success, data, message}) => {
                this.$store.dispatch("generic/setLoading", false);
                
                if(success){
                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    let fileName = `Navi${Utils.formatMonthYearExtended(this.filters.referenceMonthDate)}.xlsx`
                    fileLink.setAttribute('download', fileName);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                } else{
                    this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
  }
}

</script>

<template>
  <main>
    <div class="m-5">
      <div class="grid">
        <div class="col-2">
          <label for="dateFrom"
            :class="{'p-error':v$.filters.referenceMonthDate.$invalid && submitted}">{{$t('periodicMovementBySeaReport.referenceMonthDate')}}</label>
          <Calendar :class="{'p-inputtext-sm w-full': true}" :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
            view="month" dateFormat="mm/yy" :showTime="false" v-model="filters.referenceMonthDate" :showIcon="true"
            :showButtonBar="true" :yearNavigator="true" />

          <div
            v-if="(v$.filters.referenceMonthDate.$invalid && submitted) || v$.filters.referenceMonthDate.$pending.$response">
            <small class="p-error" v-for="error in v$.filters.referenceMonthDate.$silentErrors" :key="error.$validator">
              {{error.$message}}
            </small>
          </div>
        </div>

        <div class="col-12 lg:col-4 m-2">
          <ResponsiveButton :label="$t('btn.refresh')" icon="pi pi-replay" class="p-button-sm mx-1" @click="load()" />
          <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file" class="mx-1 p-button-sm mt-3"
            @click="exportExcel()" />
        </div>

        <div class="col-12">
          <TabView>
            <TabPanel :header="$t('periodicMovementBySeaReport.panelHeaderDischargeName')">
              <div class="grid">
                <div class="col-12" style="height: 80vh;">
                  <GenericDataTable :configuration="configuration" :category="'material-balance'"
                    :name="'periodic-movement-by-sea-report-discharge'" ref="periodicMovementBySeaReportDischarge" />
                </div>
              </div>
            </TabPanel>
            <TabPanel :header="$t('periodicMovementBySeaReport.panelHeaderChargeName')">
              <div class="grid">
                <div class="col-12" style="height: 80vh;">
                  <GenericDataTable :configuration="configuration" :category="'material-balance'"
                    :name="'periodic-movement-by-sea-report-charge'" ref="periodicMovementBySeaReportCharge" />
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </div>
  </main>
</template>